import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * This route runs when the browser lands with `#session_id=...` after the Emergent OAuth flow.
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = loc.hash || window.location.hash;
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { nav("/onboarding", { replace: true }); return; }
      const session_id = decodeURIComponent(m[1]);
      try {
        const { data } = await api.post("/auth/google", { session_id });
        localStorage.setItem("trvpro_token", data.token);
        setUser(data.user);
        toast.success(`Bienvenue ${data.user.name || ""}`);
        window.history.replaceState({}, "", "/");

        // Si une demande de landing est en attente, on la crée avant la redirection
        let goToRequests = false;
        try {
          const raw = localStorage.getItem("bp_pending_lead");
          if (raw && data.user.role !== "pro" && !data.role_pending) {
            const pending = JSON.parse(raw);
            await api.post("/leads", {
              title: (pending.description || "").slice(0, 60).trim() || "Demande de devis",
              trade: pending.trade || "bricoleur",
              description: pending.description || "",
              budget_min: 300, budget_max: 2000,
              urgency: pending.urgency || "1-mois",
              city: pending.city || data.user.city || "Paris",
            }, { headers: { Authorization: `Bearer ${data.token}` } });
            toast.success("Votre demande a été créée !");
            goToRequests = true;
          }
        } catch (err) { /* silencieux */ }
        localStorage.removeItem("bp_pending_lead");

        if (data.role_pending || !data.user.role || data.user.role_pending) {
          nav("/choose-role", { replace: true });
        } else if (data.user.role === "pro") {
          if (!data.user.subscription_active && (data.user.tokens || 0) === 0) {
            nav("/pro/activate", { replace: true });
          } else {
            nav("/pro/home", { replace: true });
          }
        } else {
          nav(goToRequests ? "/p/requests" : "/p/home", { replace: true });
        }
      } catch (e) {
        toast.error("Connexion Google impossible");
        nav("/onboarding", { replace: true });
      }
    })();
  }, [loc, nav, setUser]);

  return (
    <div className="app-shell flex flex-col items-center justify-center min-h-screen gap-4">
      <Loader2 className="w-8 h-8 text-brand animate-spin" />
      <p className="text-sm text-slate2">Connexion en cours…</p>
    </div>
  );
}
